import { render, staticRenderFns } from "./DomainFormAccess.vue?vue&type=template&id=0458a974&"
import script from "./DomainFormAccess.vue?vue&type=script&lang=ts&"
export * from "./DomainFormAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0458a974')) {
      api.createRecord('0458a974', component.options)
    } else {
      api.reload('0458a974', component.options)
    }
    module.hot.accept("./DomainFormAccess.vue?vue&type=template&id=0458a974&", function () {
      api.rerender('0458a974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/domains/DomainFormAccess.vue"
export default component.exports